<template>
  <div class="container-fluid">
    <div>
      <!-- <h3>กรอกเลขรหัสโครงการ IO R (เฉพาะตัวเลข) ของท่าน : {{ sample_ior }}</h3>
      <input v-model="sample_ior" />
      <h4>ผลการค้นหา จำนวน {{ filterIOR(sample_ior) }} งวด</h4>
      <v-select v-model="selected_installment" :options="itemIds"></v-select>
      <h4>Rows select {{ selectInstallment(selected_installment) }}</h4> -->
      <h3> เลขรหัสโครงการที่ค้นหา : {{ sample_ior }}</h3>
      <h3> งวดที่เลือก : {{ selected_installment }} </h3>
      <br>
      <div class="input-row">
        <div class="input-group">
          <label for="installments"  class="select-label">กรุณากรอกเลขรหัสโครงการ IO R (Ex.31065501) :</label>
          <input v-model="sample_ior" class="select-dropdown" v-bind:disabled="isSelectDisabled" />
          <!-- <p>ผลการค้นหา พบจำนวน {{ filterIOR(sample_ior) }} งวด</p> -->
          <p>ผลการค้นหา พบจำนวน {{ row_counter }} งวด</p>
        </div>
        <div class="input-group">
          <label for="installments"  class="select-label">กรุณาเลือกหมายเลขงวด:</label>
          <select name="installments" id="installments" v-model="selected_installment" class="select-dropdown" @change="onInstallmentSelected" v-bind:disabled="isSelectDisabled">
            <option value="">กรุณาเลือกหมายเลขงวด</option>
            <option v-for="row in filtered_rows" :key="row.id" :value="row.installment">{{ row.installment }}</option>
          </select>
          <p>งวดที่: {{ selected_installment2 }}</p>
        </div>
        <button class="my-button" @click="resetSelection" v-show="isButtonShown">
          New Search
        </button>
      </div>
      <Step v-bind:key="row.id" v-for="row in selected_row" v-bind:row="row" />
      <Timeline v-bind:key="row.id" v-for="row in selected_row" v-bind:row="row" /> 
    </div>
    <div class="row">
      <main role="main" class="col-md-12 ml-sm-auto col-lg-12 pt-3 px-4">
        <!-- <div
          class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3"
        >
          <h2>VueSheet List</h2>
          <div class="btn-toolbar mb-2 mb-md-0">
          </div>
        </div> -->

        <!-- <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>IOR</th>
                <th>INSTALLMENT</th>
                <th>STEP1</th>
                <th>STEP2</th>
                <th>STEP3</th>
                <th>STEP4</th>
                <th>STEP5</th>
              </tr>
            </thead>
            <tbody>
              <Row v-bind:key="row.id" v-for="row in rows" v-bind:row="row" />
            </tbody>
          </table>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>IOR</th>
                <th>INSTALLMENT</th>
                <th>STEP1</th>
                <th>STEP2</th>
                <th>STEP3</th>
                <th>STEP4</th>
                <th>STEP5</th>
              </tr>
            </thead>
            <tbody>
              <Row v-bind:key="row.id" v-for="row in selected_row" v-bind:row="row" />
            </tbody>
          </table>
        </div> -->

      </main>
    </div>
  
  

  </div>

</template>






<script>
// import Row from "@/components/Row.vue";
// import vSelect from 'vue-select';
import Step from "@/components/Step.vue";
import Timeline from "@/components/Timeline.vue";
const { GoogleSpreadsheet } = require("google-spreadsheet");
const creds = require("@/client_secret.json");
export default {
  name: "Sheet",
  components: {
    // 'v-select':vSelect,
    // Row,
    Step,
    Timeline,
  },
  props: ["sheet"],
  data() {
    return {
      selected_installment: '',
      selected_installment2: 0,
      installment_list: [],
      count: 0,
      sample_ior: '',
      row_counter: 0,
      rows: [],
      filtered_rows: [],
      selected_row: [],
      loading: true,
      date_step1: '1-9-65',
      current_active: 1,
      isSelectDisabled: false,
      isButtonShown: false,
 
    };
  },
  watch: {
    selected_installment(new_selected_installment, ){
      this.selectInstallment(new_selected_installment)
      this.selected_installment2 = new_selected_installment  
    },
    sample_ior(new_sample_ior, ){
      this.row_counter = this.filterIOR(new_sample_ior)
    }
  
  },
  computed: {
    itemIds() {
      return this.filtered_rows.map(item => item.installment)
    },
  },
  methods: {
    filterIOR(ior){
      this.filtered_rows = this.rows.filter(function(row) {
        return row.ior == ior;
      });
      return this.filtered_rows.length
    },
    getRowsCount(){
      return this.filtered_rows.length 
    },
    async accessSpreadSheet() {
      // 1vUNlSCHUQT1_sFkBqP_qoUKA5sdMT6JizwWEsnuAcTc
      // 16PrcWTvOQpK-Hgdl_n5ZsLyRDkheeC1ZF0dJeLbRt_A
      const doc = new GoogleSpreadsheet("16PrcWTvOQpK-Hgdl_n5ZsLyRDkheeC1ZF0dJeLbRt_A");
      await doc.useServiceAccountAuth(creds);
      await doc.loadInfo();
      const sheet = doc.sheetsByIndex[0];
      const rows = await sheet.getRows();
      this.rows = rows;
    },
    selectInstallment(ins){
      this.selected_row = this.filtered_rows.filter(row => {
        return row.installment == ins;
      });
      return this.selected_row.length
    },
    getStepClass(){
      this.theme = "step-wizard-item current-item";
      return this.theme
    },
    onInstallmentSelected() {
      this.selected_row = this.filtered_rows.filter(row => {
        return row.installment == this.selected_installment;
      });
      this.isSelectDisabled = true;
      this.isButtonShown = true;
      return this.selected_row.length
    },
    resetSelection() {
      this.selected_installment = "";
      this.isSelectDisabled = false;
      this.isButtonShown = false;
    },
  },
  created() {
    this.accessSpreadSheet();
  },
};
</script>


<style scoped>

@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@500&family=Kodchasan:wght@500&family=Noto+Sans+Thai+Looped&family=Sarabun:wght@300&display=swap');

div {

    font-family: 'IBM Plex Sans Thai', sans-serif;
    font-family: 'Kodchasan', sans-serif;
    font-family: 'Noto Sans Thai Looped', sans-serif;
    font-family: 'Sarabun', sans-serif;
    max-width: 1600px;
    width: 91vw;
    margin-right: auto;
    margin-left: auto;
    font-weight: 100;
    
}  
h3 {
    font-weight: 00;
} 

.select-label {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

.select-dropdown {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  color: #333;
  background-color: #fff;
  appearance: none;
  width: 200px;
}

.select-dropdown:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px #8a5dbe20;
}

.my-button {
  background-color: rgba(6, 46, 121, 0.765);
  color: rgb(255, 255, 255);
  transition: all 0.3s ease;
  width: 300px;
  height: 40px;
}
.my-button:hover {
  background-color: rgb(96, 195, 228);
  color: rgb(17, 98, 120);
}

.input-row {
  display: flex;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  align-items: center;
}

.input-group {
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 5px;
}


</style>
